import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getAdmins } from "../../services/admin.services";

// Async thunk to fetch admin list
export const fetchAdmins = createAsyncThunk(
  "admin/fetchAdmins",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAdmins(); // Calls your existing service function
      return response.data; // Extracting only the data
    } catch (error) {
      console.error("Error fetching admins:", error);

      // Ensure error message is a string (avoid React rendering issues)
      const errorMessage =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Failed to fetch admins";

      return rejectWithValue(errorMessage);
    }
  }
);

const initialStateList = {
  admins: [], // List of all admins
  selectedAdminId: null, // Currently selected admin ID
  adminDetails: {}, // Details of a specific admin
  socket: null, // WebSocket instance for admin
};

const adminSlice = createSlice({
  name: "admin",
  initialState: initialStateList,
  reducers: {
    // Set the list of all admins
    setAdmins: (state, action) => {
      state.admins = action.payload;
    },
    // Set the selected admin ID
    setSelectedAdmin: (state, action) => {
      state.selectedAdminId = action.payload;
    },
    // Set admin details for the selected admin
    setAdminDetails: (state, action) => {
      state.adminDetails = action.payload;
    },
    // Set the WebSocket instance
    setSocket: (state, action) => {
      state.socket = action.payload; // Set WebSocket instance
    },
    // Clear the WebSocket instance
    clearSocket: (state) => {
      if (state.socket) {
        state.socket.close(); // Close WebSocket connection if it exists
      }
      state.socket = null; // Clear WebSocket instance
    },
    // Clear all admin-related state
    clearAdmin: () => initialStateList,
  },
});

export const {
  setAdmins,
  setSelectedAdmin,
  setAdminDetails,
  setSocket,
  clearSocket,
  clearAdmin,
} = adminSlice.actions;

export default adminSlice.reducer;
